
import { defineComponent } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";

import RegisterAccountModalEC from "@/views/auth/RegisterModalEC.vue";
import RegisterAccountModal from "@/views/auth/RegisterModal.vue";
import { login as loginApi } from "@/api/login";
import { persistLoginSession } from "@/utils/authSession";

const loginSchema = Yup.object().shape({
  email: Yup.string().required().label("Username"),
  password: Yup.string().required().label("Password")
});

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
    RegisterAccountModalEC,
    RegisterAccountModal
  },
  data() {
    return {
      loginSchema,
      email: "",
      password: "",
      isLoading: false,
      showPassword: false,
      passwordFieldType: "password" as "password" | "text"
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
      this.passwordFieldType = this.showPassword ? "text" : "password";
    },
    setLoading(active: boolean) {
      this.isLoading = active;
      const button = this.$refs.submitButton as HTMLElement | undefined;
      if (!button) return;
      if (active) {
        button.setAttribute("data-kt-indicator", "on");
      } else {
        button.removeAttribute("data-kt-indicator");
      }
    },
    async onSubmitLogin(values: { email: string; password: string }) {
      await this.submitLogin({ email: values.email, password: values.password });
    },
    async submitLogin(overrides: { email?: string; password?: string } = {}) {
      const email = overrides.email ?? this.email;
      const password = overrides.password ?? this.password;

      this.email = email;
      this.password = password;
      this.setLoading(true);

      try {
        const response = await loginApi({ u: email, p: password, pt: "ovi" });
        const data = response?.data;

        if (!data) {
          Swal.fire({
            title: "",
            text: "Unable to sign in. Please try again.",
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
          });
          return;
        }

        if (data.success === false) {
          Swal.fire({
            title: "",
            text: data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
          });
          return;
        }

        if (data.success === true) {
          persistLoginSession(data, email);
          this.$router.push("/estore");
        }
      } catch {
        Swal.fire({
          title: "",
          text: "Unable to sign in. Please try again.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary"
        });
      } finally {
        this.setLoading(false);
      }
    }
  },
  mounted() {
    document.title = "OVI | Sign In";

    const u: any = this.$route.query.u;
    const p: any = this.$route.query.p;
    if (u !== undefined && u !== null && p !== undefined && p !== null) {
      this.submitLogin({
        email: atob(u),
        password: atob(p)
      });
    }
  }
});
